import template from './panicPendant.html';
import * as _ from 'lodash';

class PanicPendantController {
    /*@ngInject*/
    constructor(constants, $ngRedux) {
        this.constants = constants;
        this.$ngRedux = $ngRedux;
        this._ = _;
        this.productImage = '';
        this.images = {
            old: {
                src: '/Content/images/illustrations/illu_panicPendant.svg'
            },
            new: {
                src: '/Content/images/illustrations/illu_panicPendant2.png'
            }
        }
    }

    $onInit() {
        this.getProductSku();
    }

    getProductSku() {
        return (this._.find(this.$ngRedux.getState().system.devices.sensorsByID, { ProductSku: 'RE103' })) ? this.productImage = this.images.new : this.productImage = this.images.old;
    }
}

export default {
    template: template,
    bindings: {},
    controller: PanicPendantController
};